import { isDevice } from 'expo-device';
import * as Notifications from 'expo-notifications';
import { PermissionStatus } from 'expo-modules-core';

export async function askPushPermissions() {
	if (!isDevice) {
		return;
	}

	try {
		const statusResult = await Notifications.getPermissionsAsync();

		return statusResult.status !== PermissionStatus.GRANTED
			? await Notifications.requestPermissionsAsync()
			: statusResult;
	} catch (error) {
		return Promise.reject(new Error("Couldn't check notifications permissions"));
	}
}
